
import Vue from 'vue'
import { i18nHelper } from '@it-common/lbp_common'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import VueCropper from './VueCropper'
import 'cropperjs/dist/cropper.css'
import $ from 'jquery'
import axios from 'axios'
import util from '@/assets/js/util'
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
export default {
name: 'uploader',
components: {
Loading,
VueCropper,
TransferDom,
XHeader,
Popup,
AlertPlugin,
LoadingPlugin,
Flexbox,
FlexboxItem,
XButton
},
directives: {
TransferDom
},
props: {
message: { type: String, default: '' },
field: { type: String, default: '' },
hidehtml: { type: Boolean, default: false },
uploadPDF: { type: Boolean, default: false },
haveCropImg: {type: Boolean, default: false}
},
data () {
return {
xhr: '',
id: '',
imgUrl: '',
ot: '',
loaded: '',
isPhoto: '1',
sectionID: '',
fileID: '',
startDate: '',
endDate: '',
showLoading: false,
loading: true,
showPopup: false,
quality: 0.8,
cropImg: ''
}
},
created () {
this.id = this.$route.query.id
this.vacation = this.$route.query.type_id ? this.$route.query.type_id : ''
this.abnormal = this.$route.query.abnormal_id ? this.$route.query.abnormal_id : ''

this.fileID = this.guid()
this.sectionID = this.guid()
},
mounted () {
i18nHelper.loadLanguagePack(4159)
},
methods: {
upload () {
$('#' + this.sectionID).fadeToggle()
},
UploadFileType () {
this.$refs[this.fileID].value = ''
this.$refs[this.fileID].dispatchEvent(new MouseEvent('click'))
},
guid () {
function S4 () {
return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
},
/*
* 三个参数
* file：一个是文件(类型是图片格式)，
* w：一个是文件压缩的后宽度，宽度越小，字节越小
* objDiv：一个是容器或者回调函数
* photoCompress()
*/
photoCompress (file, w, objDiv) {
var self = this
var ready = new FileReader()
/*
开始读取指定的Blob对象或File对象中的内容.
当读取操作完成时,readyState属性的值会成为DONE,
如果设置了onloadend事件处理程序,则调用之.同时,
result属性中将包含一个data:
URL格式的字符串以表示所读取文件的内容.
*/
ready.readAsDataURL(file)
ready.onload = function () {
var re = this.result
self.canvasDataURL(re, w, objDiv)
}
},
canvasDataURL (path, obj, callback) {
var img = new Image()
img.src = path
img.onload = function () {
var that = this

var w = that.width,
h = that.height,
scale = w / h
w = obj.width || w
h = obj.height || w / scale
var quality = 0.7 

var canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')

var anw = document.createAttribute('width')
anw.nodeValue = w
var anh = document.createAttribute('height')
anh.nodeValue = h
canvas.setAttributeNode(anw)
canvas.setAttributeNode(anh)
ctx.drawImage(that, 0, 0, w, h)

if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
quality = obj.quality
}

var base64 = canvas.toDataURL('image/jpeg', quality)

callback(base64)
}
},
/**
* 将以base64的图片url数据转换为Blob
* @param urlData
* 用url方式表示的base64图片数据
*/
convertBase64UrlToBlob (urlData) {
var arr = urlData.split(','),
mime = arr[0].match(/:(.*?);/)[1],
bstr = atob(arr[1]),
n = bstr.length,
u8arr = new Uint8Array(n)

while (n--) {
u8arr[n] = bstr.charCodeAt(n)
}

return new Blob([u8arr], { type: mime })
},

UpladFile () {
var self = this
try {
var sourceType = [
'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
'application/pdf',
'application/msword',
'image/jpeg',
'image/gif',
'image/png',
'image/jpg',
'image/bmp'
]

var notImageType = ['image/jpeg', 'image/gif', 'image/png', 'image/jpg', 'image/bmp']

var fileObj = document.getElementById(this.fileID).files 
const currentDomain = window.location.hostname
const envConfigs = {
development: 'https://hr-recruitment-integration-api-dev.chehejia.com/api/v1.0', // 本地开发环境
test: 'https://hr-recruitment-integration-api-test.chehejia.com/api/v1.0', // 测试环境
production: 'https://hr-recruitment-integration-api.lixiang.com/api/v1.0' 
}
let pre
if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {

pre = envConfigs.development
} else if (currentDomain.includes('.test')) {

pre = envConfigs.test
} else {

pre = envConfigs.production
}
var url = pre + '/onboard/upload_material/' + this.id + '/' + this.field 


if (this.vacation) {
url =
process.env.API_HOST +
'/api/v1.0/attendance/upload_material/' +
this.vacation +
'/' +
this.field 
}

if (this.abnormal) {
url =
process.env.API_HOST +
'/api/v1.0/attendance/upload_image/' +
this.abnormal +
'/' +
this.field 
}

this.startDate = new Date().getTime()
for (var item = 0; item < fileObj.length; item++) {
this.showLoading = true
if (this.uploadPDF && sourceType.indexOf(fileObj[item].type) === -1) {
this.showLoading = false
this.$message.error('只支持上传gif/jpeg/png/doc/pdf等类型的文件。')
break
}


if (!this.uploadPDF && notImageType.indexOf(fileObj[item].type) === -1) {
this.showLoading = false
this.$message.error('只允许上传图片类型的文件。')
break
}

var form = new FormData() 

if (fileObj[item].size / 1024 > 15360) {
this.showLoading = false
this.$message.error('您上传的文件过大，请上传15M以下的文件，15M以上请拍照上传或压缩后上传。')
break
}

if (fileObj[item].size / 1024 > 1025 && notImageType.indexOf(fileObj[item].type) !== -1) {

self.photoCompress(
fileObj[item],
{
quality: 0.2
},
function (base64Codes) {
var bl = self.convertBase64UrlToBlob(base64Codes)
form.append('file', bl, 'file_' + Date.parse(new Date()) + '.jpg') 
self.xhr = new XMLHttpRequest() 
self.xhr.open('post', url, true) 

var _token1 = window.localStorage && window.localStorage.getItem('pre_token')
if (_token1) {
self.xhr.setRequestHeader('Authorization', 'Bearer ' + _token1)
}
self.xhr.onload = self.uploadComplete 
self.xhr.onerror = self.uploadFailed 

self.xhr.upload.onprogress = self.progressFunction 
self.xhr.upload.onloadstart = function () {

self.ot = new Date().getTime() 
self.oloaded = 0 
}

self.xhr.send(form) 
}
)
} else {

form.append('file', fileObj[item]) 
self.xhr = new XMLHttpRequest() 
self.xhr.open('post', url, true) 

var _token2 = window.localStorage && window.localStorage.getItem('pre_token')
if (_token2) {
self.xhr.setRequestHeader('Authorization', 'Bearer ' + _token2)
}
self.xhr.onload = self.uploadComplete 
self.xhr.onerror = self.uploadFailed 

self.xhr.upload.onprogress = self.progressFunction 
self.xhr.upload.onloadstart = function () {

self.ot = new Date().getTime() 
self.oloaded = 0 
}

self.xhr.send(form) 
}
}
} catch (e) {
this.$message.error('上传失败。')
this.showLoading = false
}
},


uploadComplete (evt) {

this.showLoading = false

if (evt && evt.target && evt.target.status === 401) {
util.handleUnauthorized()
return
}
var data = JSON.parse(evt.target.responseText)
this.startDate = new Date().getTime()
if (data.code === 0) {
this.$message.success('上传成功。')
if (data.field === 'identity_card_positive' || data.field === 'identity_card_back') {
this.$emit(
'success',
{
id: data.data.id,
src: data.data.pre_url,
url: data.data.filepath,
data: data,
extension: data.data.file_extension
},
data.field
)
} else {
this.$emit(
'success',
{
id: data.data.id,
src: data.data.pre_url,
url: data.data.filepath,
extension: data.data.file_extension
},
data.field
)
}
} else {
let errMessage = '上传失败。'
if (data.message) {
errMessage = data.message
}

this.$message.error(errMessage)
}
$(this.fileID + this.isPhoto).val('')
},

uploadFailed (evt) {

if (evt && evt.target && evt.target.status === 401) {
util.handleUnauthorized()
return
}
this.$message.error('上传失败。')
this.showLoading = false
},

cancleUploadFile () {
this.xhr.abort()
},

progressFunction (evt) {
this.showLoading = true

this.endDate = new Date().getTime()
if ((parseInt(this.endDate) - parseInt(this.startDate)) / 1000 > 60) {
this.$message.error('上传超时，请刷新界面，检查网络是否正常，如上传PDF文件大于10M，请压缩后上传。')
this.showLoading = false
return false
}

/*
var progressBar = document.getElementById("progressBar");
var percentageDiv = document.getElementById("percentage");

if (evt.lengthComputable) {            progressBar.max = evt.total;
progressBar.value = evt.loaded;
percentageDiv.innerHTML = Math.round(evt.loaded / evt.total * 100) + "%";
}
var time = document.getElementById("time");
var nt = new Date().getTime();
var pertime = (nt-self.ot)/1000; 
self.ot = new Date().getTime(); 
var perload = evt.loaded - self.oloaded; 
self.oloaded = evt.loaded;

var speed = perload/pertime;
var bspeed = speed;
var units = 'b/s';
if(speed/1024>1){
speed = speed/1024;
units = 'k/s';
}
if(speed/1024>1){
speed = speed/1024;
units = 'M/s';
}
speed = speed.toFixed(1);

var resttime = ((evt.total-evt.loaded)/bspeed).toFixed(1);
time.innerHTML = '，速度：'+speed+units+'，剩余时间：'+resttime+'s';
if(bspeed==0) time.innerHTML = '上传已取消';
*/
},
cropImage () {
let croppedCanvas = this.$refs.cropper.getCroppedCanvas()

if (croppedCanvas.width > 1200) {
let that = this
croppedCanvas.toBlob(function (blob) {
let reader = new FileReader()
reader.readAsDataURL(blob)
reader.onload = function () {
var img = new Image()
img.src = this.result
img.onload = function () {

var scale = this.width / this.height,
w = 1200,
h = w / scale

var canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')

var anw = document.createAttribute('width')
anw.nodeValue = w
var anh = document.createAttribute('height')
anh.nodeValue = h
canvas.setAttributeNode(anw)
canvas.setAttributeNode(anh)
ctx.drawImage(this, 0, 0, w, h)

that.cropImg = canvas.toDataURL('image/jpeg', that.quality)
const reader = new FileReader()
reader.onload = event => {
this.imgUrl = event.target.result

this.$refs.cropper.replace(event.target.result)
}
}
}
}, 'image/jpeg')
} else {
const reader = new FileReader()
reader.onload = event => {
this.cropImg = event.target.result

this.$refs.cropper.replace(event.target.result)
}
this.cropImg = croppedCanvas.toDataURL('image/jpeg', this.quality)
}
},
onClickBack () {
this.showPopup = false
},
setImage (e) {
const file = e.target.files[0]
if (!file.type.includes('image/')) {
this.$vux.alert.show({
title: '错误',
content: '请选择照片'
})
return
}
this.checkImageResolution(file, 500, 680)
.then(res => {

if (file.size / 1024 > 15360) {
this.showLoading = false
this.$message.error('您上传的文件过大，请上传15M以下的文件，15M以上请拍照上传或压缩后上传。')
return
}
if (file.size < 1024 * 100) {
this.showLoading = false
this.$message.error('照片尺寸小于100k，请选择符合要求的照片。')
return
}

if (['function', 'object'].includes(typeof FileReader)) {
const reader = new FileReader()
reader.onload = event => {
this.imgUrl = event.target.result

this.$refs.cropper.replace(event.target.result)
}

reader.readAsDataURL(file)
this.showPopup = true
} else {
this.$vux.alert.show({
title: '错误',
content: '对不起，您的浏览器不支持文件上传，请联系信息系统部' 
})
}
})
.catch(error => {
this.$message.error('照片分辨率小于500*680，请选择符合要求的照片。')

})
},
doUpload () {
let croppedCanvas = this.$refs.cropper.getCroppedCanvas()
console.log('croppedCanvas:', croppedCanvas)
if (croppedCanvas.width < 500 || croppedCanvas.height < 680) {





this.$message.error('照片分辨率小于500*680，请选择符合要求的照片。')
return
}
const currentDomain = window.location.hostname
const envConfigs = {
development: 'https://hr-recruitment-integration-api-dev.chehejia.com/api/v1.0', // 本地开发环境
test: 'https://hr-recruitment-integration-api-test.chehejia.com/api/v1.0', // 测试环境
production: 'https://hr-recruitment-integration-api.lixiang.com/api/v1.0' 
}
let pre
if (currentDomain === 'localhost' || currentDomain === '127.0.0.1') {

pre = envConfigs.development
} else if (currentDomain.includes('.test')) {

pre = envConfigs.test
} else {

pre = envConfigs.production
}
const url = pre + '/onboard/upload_material/' + this.id + '/' + this.field 
const formData = new FormData()
const fileBlob = this.convertBase64UrlToBlob(this.cropImg)
formData.append('file', fileBlob, 'file_' + Date.parse(new Date()) + '.jpg')

const _uploadToken = window.localStorage && window.localStorage.getItem('pre_token')
const _uploadHeaders = _uploadToken ? { Authorization: 'Bearer ' + _uploadToken } : {}
axios
.post(url, formData, { headers: _uploadHeaders })
.then(response => {
if (this.$vux && this.$vux.loading) {
this.$vux.loading.hide()
}
if (response.data.code === 0) {
const data = response.data
this.$emit(
'success',
{
id: data.data.id,
src: data.data.pre_url,
url: data.data.filepath,
data: data,
extension: data.data.file_extension
},
data.field
)
this.showPopup = false
} else {
this.$vux.alert.show({
title: '上传错误',
content: response.data.message ? response.data.message : '可能是照片文件太大，请重新选择一张照片再试'
})
}
})
.catch(error => {
if (this.$vux && this.$vux.loading) {
this.$vux.loading.hide()
}

if (error && error.response && error.response.status === 401) {
util.handleUnauthorized()
return
}
this.$vux.alert.show({
title: '网络错误',
content: '可能是照片文件太大，请重新选择一张照片再试，如还不行请联系信息系统部'
})
})
},
rotate (deg) {
this.$refs.cropper.rotate(deg)
},
checkImageResolution (file, minWidth, minHeight) {
return new Promise((resolve, reject) => {
const img = new Image()
img.onload = function () {
const width = img.width
const height = img.height

if (width >= minWidth && height >= minHeight) {
resolve({ width, height })
} else {

reject('照片分辨率小于500*680，请选择符合要求的照片')
}
}
img.onerror = function () {

reject('照片分辨率小于500*680，请选择符合要求的照片')
}

const reader = new FileReader()
reader.onload = function (e) {
img.src = e.target.result
}
reader.readAsDataURL(file)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/uploader.vue